import { render, staticRenderFns } from "./CaptureList.vue?vue&type=template&id=108386e3&scoped=true"
import script from "./CaptureList.vue?vue&type=script&lang=js"
export * from "./CaptureList.vue?vue&type=script&lang=js"
import style0 from "./CaptureList.vue?vue&type=style&index=0&id=108386e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108386e3",
  null
  
)

export default component.exports